<template>
	<div class="line_one" :style="barrageIsShow?'opacity:1':'opacity:0'" v-if="barrageList">
          <div class="swiper-container swiper-container1 swiper-no-swiping">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                style="width:80%;"
                v-for="(item,index) in barrageList"
                :key="index"
              >
                <div class="item">
                  <div class="item_box">
                    <div class="item_main">
                      <img src="../assets/image/banner6.png" alt />
                      <dl>
                        <dt>{{item.fang_name}}</dt>
                        <dd>{{item.doctor_name}}</dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
</template>
<script>
	import Swiper from "swiper";
	import "swiper/css/swiper.css";
	export default {
	  data() {
	  	  return {
			      barrageList: [{"fang_name":"祛风定晕汤","doctor_name":"邢月朋"},{"fang_name":"养胃饮","doctor_name":"徐富业"},{"fang_name":"宽胸保心汤","doctor_name":"颜正华"},{"fang_name":"补肾活血汤","doctor_name":"张大宁"},{"fang_name":"八仙方","doctor_name":"张永树"},{"fang_name":"钩藤熄风汤","doctor_name":"张云鹏"},{"fang_name":"肾络通","doctor_name":"赵玉庸"},{"fang_name":"三脏养肺汤","doctor_name":"周炳文"},{"fang_name":"通便汤","doctor_name":"周学文"},{"fang_name":"妇炎净","doctor_name":"朱宗元"}],
			      barrageIsShow: true
		      }
	      },
	      mounted(){
	      	this. getList()
	      },
	       methods: {
	       getList(){
	       		 this.swiper_init(".swiper-container1");
	       },
		    swiper_init(obj) {
		      var that = this;
		      that.$nextTick(function() {
		        var mySwiper = new Swiper(obj, {
                    direction: "vertical",
		          loop: true,
		          speed: 2000, //匀速时间
		          autoplay: {
		            delay: 1000,
		            stopOnLastSlide: false,
		            disableOnInteraction: false
		          }
		        });
		      });
		    }
		   }
      }
</script>
<style lang="scss">
	.line_one {
        height: 44%;
        width: 100%;
        position: relative;
        &:first-child {
          margin-top: 0.18rem;
          margin-bottom: 0.12rem;
        }
      }

      .item {
        width: 136%;
        border-radius: 0.48rem;
        font-size: 0.3rem;
        display: inline-block;
        margin-right: 0.3rem;
        padding: 0.1rem 0.3rem 0.1rem 0.2rem;
        .item_box {
          display: inline-block;
          border-radius: 0.48rem;
          background: rgba(255, 255, 255, 0.5);
          padding: 0.1rem 0.3rem 0.1rem 0.1rem;
        }
        .item_main {
          display: flex;

          img {
            width: 0.8rem;
            height: 0.8rem;
            border-radius: 50%;
            margin-right: 0.1rem;
          }
          dl {
            flex: 1;
            dt {
              color: #666;
            }
            dd {
              font-size: 0.28rem;
              color: #1d7f38;
            }
          }
        }
      }
</style>
